import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const blue = '#0d4efe';
const teal = '#01ebb2';
const ink = '#1a1a2e';
const muted = '#5a6478';

export const StyledAlreadySentDialog = styled(Dialog)(() => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(26, 26, 46, 0.52)',
    backdropFilter: 'blur(4px)',
  },
  '& .MuiDialog-paper': {
    borderRadius: 16,
    overflow: 'hidden',
    border: '1px solid rgba(13, 78, 254, 0.14)',
    boxShadow:
      '0 24px 56px rgba(13, 78, 254, 0.16), 0 8px 24px rgba(0, 0, 0, 0.06)',
    background: '#ffffff',
    maxWidth: 440,
    width: '100%',
  },
}));

export const AlreadySentDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.75),
  margin: 0,
  padding: theme.spacing(2.5, 3),
  paddingBottom: theme.spacing(2),
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.14) 0%, rgba(13, 78, 254, 0.1) 55%, rgba(13, 78, 254, 0.04) 100%)',
  borderBottom: '1px solid rgba(13, 78, 254, 0.1)',
  fontWeight: 700,
  fontSize: '1.125rem',
  lineHeight: 1.35,
  letterSpacing: '-0.02em',
  color: ink,
  '& .already-sent-icon-wrap': {
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(145deg, rgba(1, 235, 178, 0.2) 0%, rgba(13, 78, 254, 0.15) 100%)',
    border: '1px solid rgba(13, 78, 254, 0.18)',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.6)',
  },
  '& .already-sent-icon': {
    fontSize: 26,
    color: blue,
  },
}));

export const AlreadySentDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 3, 2.5),
  paddingTop: theme.spacing(2),
  '&.MuiDialogContent-root': {
    paddingTop: theme.spacing(2),
  },
  color: muted,
  fontSize: '0.95rem',
  lineHeight: 1.65,
}));

export const AlreadySentHighlight = styled('p')({
  margin: '0 0 12px',
  padding: '12px 14px',
  borderRadius: 10,
  background: 'rgba(13, 78, 254, 0.05)',
  border: '1px solid rgba(13, 78, 254, 0.12)',
  color: ink,
  fontSize: '0.9375rem',
  lineHeight: 1.5,
});

export const AlreadySentDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(0, 3, 2.75),
  gap: theme.spacing(1.25),
  justifyContent: 'flex-end',
  background: 'linear-gradient(180deg, rgba(247, 250, 252, 0.9) 0%, #f7fafc 100%)',
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
}));

export const AlreadySentOkButton = styled(Button)(() => ({
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 10,
  padding: '10px 22px',
  color: '#fff',
  background: `linear-gradient(90deg, ${teal} 0%, ${blue} 100%)`,
  boxShadow: '0 4px 14px rgba(13, 78, 254, 0.35)',
  '&:hover': {
    background: `linear-gradient(90deg, ${teal} 0%, ${blue} 100%)`,
    opacity: 0.95,
  },
}));
